import * as React from 'react';
import GrowthRateLearnMoreModal from './GrowthRateLearnMoreModal';

function GrowthRates({data} :any) {
  return (
    <div className="col-lg-8 grid-margin stretch-card">
      <div className="card financials-panel">
        <div className="card-body">
          <h4 className="card-title">Historical Growth Rates</h4>
          <p className="card-description">
            <GrowthRateLearnMoreModal />
          </p>
          <div className="table-responsive">
            <table className="table table-hover table-bordered table-sm financials-table">
              <thead>
                <tr>
                  <th className="financials-table__corner"></th>
                  <th className="financials-table__year"><strong>1 year</strong></th>
                  <th className="financials-table__year"><strong>3 years</strong></th>
                  <th className="financials-table__year"><strong>5 years</strong></th>
                  <th className="financials-table__year"><strong>7 years</strong></th>
                  <th className="financials-table__year"><strong>10 years</strong></th>
                  <th className="financials-table__year"><strong>score</strong></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="financials-table__metric"><strong>Equity Growth Rates (%)</strong></td>
                  <td className={ data.equity_growth_rates.one_year_color }>{data.equity_growth_rates.one_year_display}</td>
                  <td className={ data.equity_growth_rates.three_years_color }>{data.equity_growth_rates.three_years_display}</td>
                  <td className={ data.equity_growth_rates.five_years_color }>{data.equity_growth_rates.five_years_display}</td>
                  <td className={ data.equity_growth_rates.seven_years_color }>{data.equity_growth_rates.seven_years_display}</td>
                  <td className={ data.equity_growth_rates.ten_years_color }>{data.equity_growth_rates.ten_years_display}</td>
                  <td className="financials-table__metric">{data.equity_growth_rates.score}</td>
                </tr>
                <tr>
                  <td className="financials-table__metric"><strong>Net Income Growth Rates (%)</strong></td>
                  <td className={ data.eps_growth_rates.one_year_color }>{data.eps_growth_rates.one_year_display}</td>
                  <td className={ data.eps_growth_rates.three_years_color }>{data.eps_growth_rates.three_years_display}</td>
                  <td className={ data.eps_growth_rates.five_years_color }>{data.eps_growth_rates.five_years_display}</td>
                  <td className={ data.eps_growth_rates.seven_years_color }>{data.eps_growth_rates.seven_years_display}</td>
                  <td className={ data.eps_growth_rates.ten_years_color }>{data.eps_growth_rates.ten_years_display}</td>
                  <td className="financials-table__metric">{data.eps_growth_rates.score}</td>
                </tr>
                <tr>
                  <td className="financials-table__metric"><strong>Cash Flow Growth Rates (%)</strong></td>
                  <td className={ data.cash_growth_rates.one_year_color }>{data.cash_growth_rates.one_year_display}</td>
                  <td className={ data.cash_growth_rates.three_years_color }>{data.cash_growth_rates.three_years_display}</td>
                  <td className={ data.cash_growth_rates.five_years_color }>{data.cash_growth_rates.five_years_display}</td>
                  <td className={ data.cash_growth_rates.seven_years_color }>{data.cash_growth_rates.seven_years_display}</td>
                  <td className={ data.cash_growth_rates.ten_years_color }>{data.cash_growth_rates.ten_years_display}</td>
                  <td className="financials-table__metric">{data.cash_growth_rates.score}</td>
                </tr>
                <tr>
                  <td className="financials-table__metric"><strong>Revenue Growth Rates (%)</strong></td>
                  <td className={ data.revenue_growth_rates.one_year_color }>{data.revenue_growth_rates.one_year_display}</td>
                  <td className={ data.revenue_growth_rates.three_years_color }>{data.revenue_growth_rates.three_years_display}</td>
                  <td className={ data.revenue_growth_rates.five_years_color }>{data.revenue_growth_rates.five_years_display}</td>
                  <td className={ data.revenue_growth_rates.seven_years_color }>{data.revenue_growth_rates.seven_years_display}</td>
                  <td className={ data.revenue_growth_rates.ten_years_color }>{data.revenue_growth_rates.ten_years_display}</td>
                  <td className="financials-table__metric">{data.revenue_growth_rates.score}</td>
                </tr>
                <tr>
                  <td className="financials-table__metric"><strong>Competitive Advantage Score</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="financials-table__metric">{data.moat_score}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GrowthRates;
